/* GOPSHOP 7.7 – Liquid Glass: Lichtreflex folgt dem Mauszeiger (nur Geräte mit Maus). */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.gop-glass, .gt, .gmc__card, .gw__card, .gop-hero__ask, .gh__search, .gop-faq__item, .gop-step, .gop-btn, .gwc--float, .card-wrapper .card, .gop-notice__pill';
  var cur = null, ev = null, raf = 0;
  function tick() {
    raf = 0;
    if (!ev) return;
    var el = ev.target && ev.target.closest ? ev.target.closest(SEL) : null;
    if (cur && cur !== el) { cur.style.removeProperty('--lg-x'); cur.style.removeProperty('--lg-y'); }
    cur = el;
    if (!el) return;
    var r = el.getBoundingClientRect();
    el.style.setProperty('--lg-x', (((ev.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
    el.style.setProperty('--lg-y', (((ev.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
  }
  document.addEventListener('pointermove', function (e) { ev = e; if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
})();
